 <!-- contenido-->
 <button type="button" class="btn btn-danger btn-round"  style="float: right;" (click)="cerrar()">Cerrar </button>

 <div class="block-header">
    <div class="row clearfix">
            <h1 class="color">Detalles de la Tarea</h1>
        
    </div>
</div>
<!-- contenido -->
<div id="ver_tareas" style="">

    <div class="container-fluid">

      


        <div class="row clearfix">
            <div class="col-lg-12 col-md-12">

              <div class="card">
                    <!-- <div class="header">
                        <h2>Información</h2>
                    </div> -->
                    <ul class="list-group">
                        <!-- <li class="list-group-item">
                            <small class="text-muted">Proyecto: </small>
                            <p class="mb-0" id="m_proyecto">Proyectos</p>
                        </li> -->
                        <li class="list-group-item">
                            <small class="text-muted">Nombre de la Tarea: </small>
                            <p class="mb-0" id="m_actividad">{{info.nombre}}</p>
                        </li>
                        <li class="list-group-item">
                            <small class="text-muted">Comentario: </small>
                            <p class="mb-0" id="m_comentario" [innerHTML]="info.comentarios">
                                
                            </p>
                        </li>
                        <li class="list-group-item">
                            <small class="text-muted">Fecha: </small>
                            <p class="mb-0" id="m_fecha" [innerHTML]="info.fecha"></p>
                        </li>
                        <li class="list-group-item">
                            <small class="text-muted">Importancia: </small>
                            <p class="mb-0 badge {{info.importancia_color}}" id="m_importancia">{{info.importancia}}</p>
                        </li>
                        <li class="list-group-item">
                            <small class="text-muted">Estatus: </small>
                            <p class="mb-0 badge badge-primary" style="margin-left: 36px;" id="m_estatus">{{info.estatus}}</p>
                        </li>

                    </ul>
                </div>


                <div class="card c_grid c_yellow">
                  <div class="header">
                    <h2>Responsables</h2>
                  </div>
                    <div class="body text-center">
                          
                        <div class="row" style="margin-top: 10px;" *ngFor="let images of datos?.users">                
                            <div class="col-1">                 
                            <img alt="image" src="{{url+''+images.img}}" class="rounded-circle " width="35">               
                            </div>                
                             <div class="col-11" style="margin-top: 5px;">{{images.name}} {{images.last_name}}</div>              
                        </div>
                    
                </div>

                <div class="card c_grid c_yellow">
                    <div class="header">
                      <h2>Documentos</h2>
                    </div>
                      <div class="body ">
                        <div class="container-fluid">
                            <p  *ngIf="datos?.doc.length == 0">No se tienen documentos</p> 

                          <div style="margin-top: 10px;" *ngFor="let docs of datos?.doc">  
                            <div class="row">
                                <div class="col-1">                 
                                 <a href="{{url_doc+''+docs.doc}}" download="{{docs.doc}}" target="_blank"><i class="fa fa-file color" aria-hidden="true" style="    font-size: 20px; margin-top: 5px;"></i></a>
                                </div>
                                <div class="col-11">                 
                                 <a href="{{url_doc+''+docs.doc}}" download="{{docs.doc}}" target="_blank"><p class="color">{{docs.doc}}</p> </a>
                                </div>
                            </div>        
                          </div>

                       
                    </div>
                  </div>


            </div>
            <div class="col-lg-12 col-md-12">

                <form #commentForm="ngForm" (ngSubmit)="onSubmit(commentForm)" class="form-auth-small m-t-20">
                <div class="card">
                  <div class="header">
                    <h2>Escribir un Comentario</h2>
                  </div>
                    <div class="body">
                        <ckeditor [data]="comentario.comentario" [(ngModel)]="comentario.comentario" name="comentario" type="inline"></ckeditor>
                        <br>
                        <button class="btn btn-success btn-round pull-right" [disabled]="!commentForm.form.valid" style="margin-top: 30px;">
                            <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loading, ' fa-refresh fa-spin':loading }"></i> Guardar Comentario</button>
                        
                    </div>
                </div>
                </form>
                <div class="card">
                    <div class="header">
                        <h2>Comentarios</h2>
                       
                    </div>
                    <div class="body">

                        <ul class="timeline">
                            <p  *ngIf="datos?.comentarios.length == 0">No se tienen comentarios</p>  

                             <div style="margin-top: 10px;" *ngFor="let coment of datos?.comentarios"> 
                                <div class="row">
                                    <div class="col-2">                 
                                        <img alt="image" src="{{url+''+coment.img}}" class="rounded-circle " width="35"> 
                                    </div>
                                    <div class="col-10">     
                                        <p style="color:#a0a6af;" [innerHTML]="coment.fecha"></p>   
                                        <i class="fa fa-times" aria-hidden="true" style="float: right; cursor: pointer;" (click)="eliminar_comentario(coment.id_comentarios)"></i>
                                    <p class="color">{{coment.name}} {{coment.last_name}}</p>         
                                     <p style="color:#a0a6af;" [innerHTML]="coment.texto"></p> 
                                    </div>
                                </div>
                               
                                <br>          
                            </div>


                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- contenido -->